import { get } from "../../utils/BaseService";

export async function getInvoicePaymentByInvoiceId(dispatch: any, id: string) {
  return await get(dispatch, `/invoicePayments/invoice/${id}`,null);
}